module.exports = __webpack_public_path__ + "img/mission-handshake.46458d62.png";